import JSZip from "jszip";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";
import CopyFolder from "./CopyFolder";
import MoveFolder from "./MoveFolder";
// import FilePreview from "./FilePreview";
import { CiSearch } from "react-icons/ci";
import UpdateFolder from "./UpdateFolder";
import AddNewFolder from "./AddNewFolder";
import { IoFolder } from "react-icons/io5";
import DuplicateFolder from "./DuplicateFolder";
import GenerateZipFile from "./GenerateZipFile";
import UseToggle from "../../../Hooks/UseToggle";
import { AiOutlineFilePdf } from "react-icons/ai";
import { FaFile, FaFolder } from "react-icons/fa";
import ExtractedZipFile from "./ExtractedZipFile";
import { useEffect, useRef, useState } from "react";
import { GoDuplicate, GoFileZip } from "react-icons/go";
import { BsFillFolderFill, BsImage } from "react-icons/bs";
import FileManagementSidebar from "./FileManagementSidebar";
import UploadMultiFilesFolders from "./UploadMultiFilesFolders";
import { FiEdit, FiPlusSquare, FiTrash, FiUpload } from "react-icons/fi";
import { s3FileManagerServices } from "../../../APIServices/SitePilotManagement/s3FileManagerServices";
import { Breadcrumb, Button, Col, Collapse, Container, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import { GrCut, GrDocumentCsv, GrDocumentExcel, GrDocumentPpt, GrDocumentRtf, GrDocumentTxt, GrDocumentWord } from "react-icons/gr";

const FileManagement = ({
}) => {
  const toggles = UseToggle();
  const [loader, setLoader] = useState([]);
  const [objectData, setObjectData] = useState("");
  const [trashData, setTrashData] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [fileURL, setFileURL] = useState("");
  const [viewType, setViewType] = useState("grid");
  const [breadcrumb, setBreadcrumb] = useState(false);
  const [breadcrumbData, setBreadcrumbData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [fileManager, setFileManager] = useState([]);
  const [lastSelectedIndex, setLastSelectedIndex] = useState(null);
  const AppsRef = useRef(null);
  const gridRef = useRef(null);
  const addRef = useRef(null);
  const updateRef = useRef(null);
  const copyRef = useRef(null);
  const moveRef = useRef(null);
  const duplicateRef = useRef(null);
  const uploadRef = useRef(null);
  const generateZipRef = useRef(null);
  const extractZipRef = useRef(null);
  const fileURLRef = useRef(null);
  const getS3Folders = async (path) => {
    setLoader(true);
    setSelectedItems([])
    let data
    if (objectData?.fullPath) {
      data = await s3FileManagerServices.getS3Folders(trashData ? "trash" : "root", searchData, objectData?.fullPath, "both");
    } else {
      if (!path) {
        setBreadcrumbData([])
      }
      data = await s3FileManagerServices.getS3Folders(trashData ? "trash" : "root", searchData, path, "both");
    }
    setFileManager(data?.data || []);
    setLoader(false);
  };

  useEffect(() => {
    getS3Folders();
  }, [searchData, objectData, trashData]);

  const isSelected = (fullPath) =>
    selectedItems.some((item) => item.fullPath === fullPath);

  const handleItemClick = (e, item, index) => {
    const { fullPath, url, name } = item;
    if (e.shiftKey && lastSelectedIndex !== null) {
      const start = Math.min(lastSelectedIndex, index);
      const end = Math.max(lastSelectedIndex, index);
      const rangeItems = fileManager.slice(start, end + 1).map((f) => ({
        fullPath: f.fullPath,
        url: f.url,
      }));

      setSelectedItems(rangeItems);
    } else {
      setSelectedItems([{ fullPath, url, name }]);
      setLastSelectedIndex(index);
    }
  };

  const handleCheckboxChange = (item, index) => {
    const { fullPath, url, name } = item;
    setLastSelectedIndex(index);

    setSelectedItems((prev) => {
      const exists = prev.some((x) => x.fullPath === fullPath);
      if (exists) {
        return prev.filter((x) => x.fullPath !== fullPath);
      } else {
        return [...prev, { fullPath, url, name }];
      }
    });
  };

  const deleteS3FolderFile = async (key) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Delete this selected Items!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Delete it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.key = key;
        let data = await s3FileManagerServices.deleteS3FolderFile(userData);
        if (data?.statusCode === 200) {
        }
      }
    });
  };

  const softDeleteS3Folder = async (path) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Delete this folder!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Delete it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.path = path;
        userData.type = "delete";
        let data = await s3FileManagerServices.softDeleteS3Folder(userData);
        if (data?.statusCode === 200) {
        }
      }
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideToolbar = AppsRef?.current?.contains(event.target);
      const clickedInsideGrid = gridRef?.current?.contains(event.target);
      const clickedInsideAdd = addRef?.current?.contains(event.target);
      const clickedInsideUpdate = updateRef?.current?.contains(event.target);
      const clickedInsideCopy = copyRef?.current?.contains(event.target);
      const clickedInsideMove = moveRef?.current?.contains(event.target);
      const clickedInsideDuplicate = duplicateRef?.current?.contains(event.target);
      const clickedInsideUpload = uploadRef?.current?.contains(event.target);
      const clickedInsideGenerateZip = generateZipRef?.current?.contains(event.target);
      const clickedInsideExtractZip = extractZipRef?.current?.contains(event.target);
      const clickedInsideFileURL = fileURLRef?.current?.contains(event.target);
      const clickedInMenu = event.target.closest(".node-menu") || event.target.closest(".kebab-icon");
      if (
        !clickedInsideToolbar &&
        !clickedInsideGrid &&
        !clickedInsideAdd &&
        !clickedInsideUpdate &&
        !clickedInsideCopy &&
        !clickedInsideMove &&
        !clickedInsideDuplicate &&
        !clickedInsideUpload &&
        !clickedInsideGenerateZip &&
        !clickedInsideExtractZip &&
        !clickedInsideFileURL &&
        !clickedInMenu
      ) {
        setSelectedItems([]);
        setFileURL("");
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => document.removeEventListener("click", handleClickOutside, true);
  }, []);

  useEffect(() => {
    if (objectData?.fullPath) {
      let path = objectData?.fullPath?.split("/").filter(Boolean);
      setBreadcrumbData(path);
    }
  }, [objectData]);

  function getPathOnClick(clicked) {
    const index = breadcrumbData.indexOf(clicked);
    if (index === -1) return "";
    let result = breadcrumbData.slice(0, index + 1).join("/") + "/";
    setBreadcrumbData(breadcrumbData.slice(0, index + 1))
    setObjectData({ ...objectData, name: clicked, fullPath: result })
    getS3Folders(result)
  }

  const isFile = (key) => {
    if (key) {
      const lastPart = key.split("/").filter(Boolean).pop() || "";
      const ext = lastPart.includes(".") ? lastPart.split(".").pop() : "";
      return ext;
    }
  };

  const downloadDocumentFile = async (selectedItems) => {
    if (selectedItems.length === 1) {
      const anchor = document.createElement("a");
      anchor.href = selectedItems?.[0]?.url;
      anchor.rel = "noopener noreferrer";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      return;
    } else {
      const zip = new JSZip();
      for (const item of selectedItems) {
        const response = await fetch(item?.url);
        if (!response.ok) {
          continue;
        }
        const blob = await response.blob();
        zip.file(item?.name, blob);
      }
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, `${objectData?.name}.zip`);
    }
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md={3} className="p-0 border-end">
            <FileManagementSidebar
              setObjectData={setObjectData}
              objectData={objectData}
              setTrashData={setTrashData}
              trashData={trashData}
            />
          </Col>
          <Col md={9} className="p-0">
            <div
              ref={AppsRef}
              className="justify-content-between border-bottom hstack p-1"
              style={{ height: 34 }}
            >
              <div
                className="hstack gap-2">
                {(!trashData && (selectedItems?.length === 0 || (selectedItems?.length === 1 && !isFile(selectedItems?.[0]?.fullPath)))) &&
                  <>
                    <FiPlusSquare
                      title="Add New Folder"
                      className="CP"
                      onClick={() => toggles.setToggle()}
                    />
                    <div className="vr"></div>
                    <FiUpload
                      title="Upload File or Folder"
                      className="CP"
                      onClick={() => toggles.setToggle5()}
                    />
                    <div className="vr"></div>
                  </>
                }
                {(!trashData && selectedItems?.length > 0) && (
                  <>
                    {selectedItems?.length === 1 && (
                      <>
                        <FiEdit
                          title="Rename"
                          className="CP"
                          onClick={() => toggles.setToggle1()}
                        />
                        <div className="vr"></div>
                        <GoDuplicate
                          title="Duplicate"
                          className="fa-solid fa-clone CP"
                          onClick={() => toggles.setToggle4()}
                        />
                        <div className="vr"></div>
                        {isFile(selectedItems?.[0]?.fullPath) === "zip" &&
                          <>
                            <GoFileZip
                              title="Extract Zip"
                              className="CP"
                              onClick={() => toggles.setToggle7()}
                            />
                            <div className="vr"></div>
                          </>
                        }
                      </>
                    )}
                    {selectedItems?.length > 0 && (
                      <>
                        <GrCut
                          title="Cut"
                          className="CP"
                          onClick={() => toggles.setToggle3()}
                        />
                        <div className="vr"></div>
                        <GoDuplicate
                          title="Copy in Other Folder"
                          className="CP"
                          onClick={() => toggles.setToggle2()}
                        />
                        <div className="vr"></div>
                        <GoFileZip
                          title="Generate Zip File"
                          className="CP"
                          onClick={() => toggles.setToggle6()}
                        />
                        <div className="vr"></div>
                        <FiTrash
                          title="Delete"
                          className="CP text-danger"
                          onClick={() => softDeleteS3Folder(selectedItems?.map(item => item.fullPath))}
                        />
                        <div className="vr"></div>
                      </>
                    )}
                  </>
                )}
                {(trashData && selectedItems?.length > 0) &&
                  <>
                    <FiTrash
                      title="Delete"
                      className="CP text-danger"
                      onClick={() => deleteS3FolderFile(selectedItems)}
                    />
                    <div className="vr"></div>
                  </>
                }
                <div className="position-relative">
                  <CiSearch
                    className="CP position-absolute"
                    title="Search"
                    style={{ width: 15, top: 6, left: 7 }}
                  />
                  <Form.Control
                    type="search"
                    onChange={(e) => setSearchData(e.target.value)}
                    value={searchData}
                    placeholder="Search..."
                    style={{ width: 250, padding: "3px 5px 3px 25px" }}
                  />
                </div>
              </div>

              <div className="hstack gap-2">
                {(selectedItems?.length > 0 && selectedItems.every(item => !!item.url)) &&
                  <Button
                    variant="outline-primary"
                    size="sm"
                    style={{ fontSize: 12 }}
                    onClick={() => downloadDocumentFile(selectedItems)}
                  >
                    Download File{selectedItems?.length > 1 ? "s" : ""}
                  </Button>
                }
                <Button
                  variant={breadcrumb ? "outline-danger" : "outline-success"}
                  size="sm"
                  style={{ fontSize: 12 }}
                  onClick={() => setBreadcrumb(!breadcrumb)}
                >
                  {!breadcrumb ? "View" : "Hide"} Breadcrumb
                </Button>
                <Button
                  variant={viewType === "grid" ? "primary" : "outline-primary"}
                  size="sm"
                  style={{ fontSize: 12 }}
                  onClick={() => { setViewType("grid") }}
                >
                  Grid View
                </Button>
                <Button
                  variant={viewType === "list" ? "primary" : "outline-primary"}
                  size="sm"
                  style={{ fontSize: 12 }}
                  onClick={() => setViewType("list")}
                >
                  List View
                </Button>
              </div>
            </div>
            <Collapse in={breadcrumb}>
              <div className="toolbar border-bottom">
                <Breadcrumb className="m-0">
                  <Breadcrumb.Item
                    active={breadcrumbData?.length === 0}
                    className="fw-bold"
                    onClick={() => {
                      setObjectData("")
                    }}
                  >
                    File Management
                  </Breadcrumb.Item>
                  {breadcrumbData?.length > 0 && breadcrumbData?.map((pathName, index) => (
                    <Breadcrumb.Item
                      key={index}
                      className="fw-bold"
                      active={index === breadcrumbData?.length - 1}
                      onClick={() => {
                        if (index !== breadcrumbData?.length - 1) {
                          getPathOnClick(pathName)
                        }
                      }}
                    >
                      {pathName}
                    </Breadcrumb.Item>
                  ))}
                </Breadcrumb>
              </div>
            </Collapse>
            <Container fluid>
              <Row>
                <Col md={fileURL ? 8 : 12} className={`overflow-auto p-0 ${fileURL && "border-end"}`} style={{ height: breadcrumb ? "calc(100vh - 124px)" : "calc(100vh - 90px)" }}>
                  {loader ? (
                    <div className="hstack justify-content-center h-100">
                      <Spinner />
                    </div>
                  ) : fileManager?.length === 0 ? (
                    <div className="hstack justify-content-center h-100">
                      <p className="m-0 text-muted" style={{ fontSize: 12 }}>File or Folder not found!</p>
                    </div>
                  ) : (
                    <>
                      {/* GRID VIEW */}
                      {viewType === "grid" && (
                        <div ref={gridRef} className="d-flex flex-wrap">
                          {fileManager?.map((item, index) => (
                            <div
                              key={item.name}
                              className={`text-center m-2 position-relative CP p-1 ${isSelected(item.fullPath) ? "selectedMenu br3" : "" }`}
                              onClick={(e) => handleItemClick(e, item, index)}
                              onDoubleClick={(e) => {
                                if (!item.isFile) {
                                  getS3Folders(item.fullPath)
                                  e.stopPropagation()
                                } else {
                                  setFileURL(item.url)
                                  e.stopPropagation()
                                }
                              }}
                              title={`Name: ${item.name}\nType: Folder\nSize: ${item.sizeMB}\nCreated DT: ${item.createdAt}\nUpdated DT: ${item.updatedAt}`}
                              style={{ width: 120, userSelect: "none" }}
                            >
                              <Form.Check
                                type="checkbox"
                                checked={isSelected(item.fullPath)}
                                onChange={() => handleCheckboxChange(item, index)}
                                onClick={(e) => e.stopPropagation()}
                                className="position-absolute top-0 start-0 m-1"
                              />
                              {!item.isFile ? (
                                item?.children?.length > 0 ?
                                  <>
                                    {item?.name === "Uncategories" ?
                                      <IoFolder className="text-info" style={{ fontSize: 60 }} />
                                      :
                                      <BsFillFolderFill className="text-warning" style={{ fontSize: 60 }} />
                                    }
                                  </>
                                  :
                                  <>
                                    {item?.name === "Uncategories" ?
                                      <IoFolder className="text-info" style={{ fontSize: 60 }} />
                                      :
                                      <FaFolder className="text-warning" style={{ fontSize: 60 }} />
                                    }
                                  </>
                              ) : (
                                <>
                                  {isFile(item?.fullPath) === "csv" ?
                                    <GrDocumentCsv className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                    : isFile(item?.fullPath) === "xpt" ?
                                      <FaFile className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                      : (isFile(item?.fullPath) === "jpeg" || isFile(item?.fullPath) === "jpg" || isFile(item?.fullPath) === "png") ?
                                        <BsImage className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                        : (isFile(item?.fullPath) === "xls" || isFile(item?.fullPath) === "xlsx") ?
                                          <GrDocumentExcel className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                          : isFile(item?.fullPath) === "pdf" ?
                                            <AiOutlineFilePdf className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                            : (isFile(item?.fullPath) === "doc" || isFile(item?.fullPath) === "docx") ?
                                              <GrDocumentWord className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                              : (isFile(item?.fullPath) === "ppt" || isFile(item?.fullPath) === "pptx") ?
                                                <GrDocumentPpt className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                                : (isFile(item?.fullPath) === "zip") ?
                                                  <GoFileZip className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                                  : isFile(item?.fullPath) === "txt" ?
                                                    <GrDocumentTxt className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                                    : isFile(item?.fullPath) === "rtf" ?
                                                      <GrDocumentRtf className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                                      :
                                                      <FaFile className="text-secondary" style={{ fontSize: 50, marginTop: 8 }} />
                                  }
                                </>
                              )}
                              <div className="mt-1 small text-truncate fontSize12">{item.name}</div>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* LIST VIEW */}
                      {viewType === "list" && (
                        <Table className="m-0 custom-table" borderless hover>
                          <thead className="position-sticky top-0 z-1 bg-white">
                            <tr>
                              <th>Name</th>
                              <th>
                                Created Date | Time
                              </th>
                              <th>
                                Updated Date | Time
                              </th>
                              <th>Type</th>
                              <th>Size</th>
                            </tr>
                          </thead>
                          <tbody>
                            {fileManager?.map((item, index) => (
                              <tr
                                key={item.name}
                                className={`${isSelected(item.fullPath) ? "selectedMenu" : ""} CP`}
                                onClick={(e) => handleItemClick(e, item, index)}
                                onDoubleClick={(e) => {
                                  if (!item.isFile) {
                                    getS3Folders(item.fullPath)
                                    e.stopPropagation()
                                  }
                                }}
                                title={`Name: ${item.name}\nType: Folder\nSize: ${item.sizeMB}\nCreated DT: ${item.createdAt}\nUpdated DT: ${item.updatedAt}`}
                                style={{ userSelect: "none" }}
                              >
                                <td className="border-0">
                                  <div className="hstack gap-2">
                                    <Form.Check
                                      type="checkbox"
                                      checked={isSelected(item.fullPath)}
                                      onChange={() =>
                                        handleCheckboxChange(item, index)
                                      }
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                    <div style={{ width: 15 }}>
                                      {!item.isFile ? (
                                        item?.children?.length > 0 ?
                                          <>
                                            {item?.name === "Uncategories" ?
                                              <IoFolder className="text-info" style={{ fontSize: 15 }} />
                                              :
                                              <BsFillFolderFill className="text-warning" style={{ fontSize: 15 }} />
                                            }
                                          </>
                                          :
                                          <>
                                            {item?.name === "Uncategories" ?
                                              <IoFolder className="text-info" style={{ fontSize: 15 }} />
                                              :
                                              <FaFolder className="text-warning" style={{ fontSize: 15 }} />
                                            }
                                          </>
                                      ) : (
                                        <>
                                          {isFile(item?.fullPath) === "csv" ?
                                            <GrDocumentCsv className="text-secondary" style={{ fontSize: 15 }} />
                                            : isFile(item?.fullPath) === "xpt" ?
                                              <FaFile className="text-secondary" style={{ fontSize: 15 }} />
                                              : (isFile(item?.fullPath) === "jpeg" || isFile(item?.fullPath) === "jpg" || isFile(item?.fullPath) === "png") ?
                                                <BsImage className="text-secondary" style={{ fontSize: 15 }} />
                                                : (isFile(item?.fullPath) === "xls" || isFile(item?.fullPath) === "xlsx") ?
                                                  <GrDocumentExcel className="text-secondary" style={{ fontSize: 15 }} />
                                                  : isFile(item?.fullPath) === "pdf" ?
                                                    <AiOutlineFilePdf className="text-secondary" style={{ fontSize: 15 }} />
                                                    : (isFile(item?.fullPath) === "doc" || isFile(item?.fullPath) === "docx") ?
                                                      <GrDocumentWord className="text-secondary" style={{ fontSize: 15 }} />
                                                      : (isFile(item?.fullPath) === "ppt" || isFile(item?.fullPath) === "pptx") ?
                                                        <GrDocumentPpt className="text-secondary" style={{ fontSize: 15 }} />
                                                        : (isFile(item?.fullPath) === "zip") ?
                                                          <GoFileZip className="text-secondary" style={{ fontSize: 15 }} />
                                                          : isFile(item?.fullPath) === "txt" ?
                                                            <GrDocumentTxt className="text-secondary" style={{ fontSize: 15 }} />
                                                            : isFile(item?.fullPath) === "rtf" ?
                                                              <GrDocumentRtf className="text-secondary" style={{ fontSize: 15 }} />
                                                              :
                                                              <FaFile className="text-secondary" style={{ fontSize: 15 }} />
                                          }
                                        </>
                                      )}
                                    </div>
                                    <span className="text-truncate">{item.name}</span>
                                  </div>
                                </td>
                                <td className="border-0">{item.createdAt}</td>
                                <td className="border-0">{item.updatedAt}</td>
                                <td className="border-0">{!item.isFile ? "Folder" : <span className="text-uppercase">{isFile(item?.fullPath)}</span>}</td>
                                <td className="border-0">{item.sizeMB}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      )}
                    </>
                  )}
                </Col>
                {fileURL && (
                  <Col md={4} className="overflow-auto" style={{ height: breadcrumb ? "calc(100vh - 124px)" : "calc(100vh - 90px)" }}>
                    {/* <FilePreview FileUrl={fileURL} ref={fileURLRef} HeightData={breadcrumb ? "calc(100vh - 132px)" : "calc(100vh - 98px)"} /> */}
                  </Col>
                )}
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
      <AddNewFolder
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title="Add New Folder"
        getTotalS3Folders={getS3Folders}
        folderData={selectedItems?.length === 1 ? selectedItems?.[0]?.fullPath : objectData}
      />
      <UpdateFolder
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        Title={`Update Selected Item`}
        getTotalS3Folders={getS3Folders}
        sourceKey={selectedItems?.map(item => item.fullPath)}
        ref={updateRef}
      />
      <CopyFolder
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        Title={`Copy Selected Item`}
        getTotalS3Folders={getS3Folders}
        sourceKey={selectedItems?.map(item => item.fullPath)}
        ref={copyRef}
      />
      <MoveFolder
        Show={!toggles.toggle3}
        Hide={toggles.setToggle3}
        Title={`Move Selected Item`}
        getTotalS3Folders={getS3Folders}
        sourceKey={selectedItems?.map(item => item.fullPath)}
        ref={moveRef}
      />
      <DuplicateFolder
        Show={!toggles.toggle4}
        Hide={toggles.setToggle4}
        Title={`Duplicate Selected Item`}
        getTotalS3Folders={getS3Folders}
        sourceKey={selectedItems?.map(item => item.fullPath)}
        ref={duplicateRef}
      />
      <UploadMultiFilesFolders
        Show={!toggles.toggle5}
        Hide={toggles.setToggle5}
        Title={`Upload Files / Folders`}
        getTotalS3Folders={getS3Folders}
        sourceKey={selectedItems?.length === 1 ? selectedItems?.[0]?.fullPath : objectData?.fullPath}
        ref={uploadRef}
      />
      <GenerateZipFile
        Show={!toggles.toggle6}
        Hide={toggles.setToggle6}
        Title={`Generate Zip`}
        getTotalS3Folders={getS3Folders}
        sourceKey={selectedItems?.map(item => item.fullPath)}
        ref={generateZipRef}
      />
      <ExtractedZipFile
        Show={!toggles.toggle7}
        Hide={toggles.setToggle7}
        Title={`Extract Zip`}
        getTotalS3Folders={getS3Folders}
        sourceKey={selectedItems?.map(item => item.fullPath)}
        ref={extractZipRef}
      />
    </>
  );
};

export default FileManagement;
